<template>
  <div id="faqSection">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12 faq-distance">
          <span id="faqHeadline" class="faq-headline" :style="{ '--color' : non_repeat.headline_color}" v-html="non_repeat.headline"></span>
        </div>
      </div>
      <Tabs slide-duration="0">
        <template v-for="(tab_detail, index) in tab_details">
            <TabItem :id="'tab'+index" :name="tab_detail.non_repeat.tab" class="col-md-12 col-xs-12 faq-panel no-padding" :key="'item-' + index">
                <v-collapse-wrapper class="sp_panel" v-for="(repeat, index) in tab_detail.repeat" :key="index">
                  <div class="panel-heading" @click="switchIcon">
                        <span class="panel-title prodbenefits" v-collapse-toggle>
                          <h3 class="no-margin">
                            <p :id="'title'+index" v-html="repeat.title" class="panel-sub-title"></p>
                            <i class="glyphicon glyphicon-chevron-down"></i>
                          </h3>
                        </span>
                  </div>
                  <div class="panel-collapse" v-collapse-content>
                    <div class="panel-body"><p id="faqDescription" v-html="repeat.text"></p></div>
                  </div>
                </v-collapse-wrapper>
            </TabItem>
        </template>
      </Tabs>
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <a @click="scrollToTop()" :href="non_repeat.button_link">
            <button type="submit" id="faqButton" class="btn btn-primary faq-button">{{non_repeat.button_text }}</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQSection",
  props: ['tab_details', 'faqEntries', 'non_repeat'],
  data: function () {
    return {
      currentItem: null
    }
  },
  methods: {
    switchIcon: function (e) {
      let icon = e.target;
      if (icon.children.length > 0) {
        icon = icon.children.item(0);
      }
      let curClass = icon.getAttribute("class");
      switch (curClass) {
        case "glyphicon glyphicon-chevron-down":
          if (this.currentItem !== null) {
            this.currentItem.setAttribute("class", "glyphicon glyphicon-chevron-down");
          }
          icon.setAttribute("class", "glyphicon glyphicon-chevron-up");
          this.currentItem = icon;
          break;
        case "glyphicon glyphicon-chevron-up":
          icon.setAttribute("class", "glyphicon glyphicon-chevron-down");
          this.currentItem = icon;
          break;
      }
    },
    scrollToTop() {
      window.scrollTo(0, 350);
    }
  }
}
</script>

<style scoped lang="scss">

@import "../../css/variables.scss";

.container{
  padding: 0;
}
.glyphicon{
  top:-35px;
  left:95%;
}
.faq-panel{
  margin-top: 20px;
  padding: 0;

  @media (min-width: $sm-breakpoint-min) {
    padding: 0 43px;
  }
}
.sp_panel{
  border-bottom: 1px solid gray;
}
h1, h2, h3, h4, h5, h6{
  margin-bottom: -20px;
}
p{
  margin-top: 20px;
}
.panel-heading {
  padding-right: 0;
  padding-left: 0;
}
.panel-sub-title {
  padding-right: 20px;
}
@media (min-width: 377px) and (max-width: 767px) {
  .faq-distance{
    margin-top: 40px;
  }
}
@media(min-width: 768px) and (max-width: 991px){
  .faq-distance{
    padding-left: 25px;
  }
}
</style>
